module.exports = __webpack_public_path__ + "img/watermark_blue.d2fc9ebf.png";